










































































































import _ from 'lodash'
import A from '../utilities/alpha'
import Table from '../components/TestQueue/Table.vue'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import { ViewOption, Mode, OrgViewOption, ListLocation } from '@/utilities/priority-helpers'
import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import { Button } from '@alpha/ink'
import loadingGif from '@/assets/img/loading.gif'
import ToastAlert from '@/components/Toast.vue'
import * as graph from '@shared/types/graphql'
import { OrganizationUsersQuery, OrganizationPriorityQuery } from '@/api/graphql-sdk.generated'
import store from '@/store'
import api from '@/api'
import analytics from '@/analytics'
export type OrganizationUsers = OrganizationUsersQuery['organizationUsers']
export type ActiveTest = OrganizationPriorityQuery['organizationPriority']['activeTests'][0]
export type PriorityList = OrganizationPriorityQuery['organizationPriority']['priority']
export type PriorityListItem = PriorityList['list'][0]
type DatedTest = OrganizationPriorityQuery['organizationPriority']['datedOrgTests'][0]
@Component({
  components: {
    Table,
    Multiselect,
    Button,
    ToastAlert
  }
})
export default class TestQueue extends Vue {
  @Prop({ required: true }) orgMode!: boolean
  tapId: string | null = null
  workspaces: graph.Workspace[] = [] // same as tapid // fails on load with no data
  users: OrganizationUsers = []
  org = {
    id: '',
    name: ''
  }

  loading = true
  loadingGif = loadingGif
  currentFilter: ViewOption | null = { isOrg: this.orgMode, name: '' }
  activeTests: ActiveTest[] = []
  priority: PriorityList = { list: [], uuid: '' }
  datedOrgTests: DatedTest[] = []
  editable = false
  draggedTest: ActiveTest | null = null
  priorityListBackup: PriorityListItem[] = []
  workspacePriorityBackup: string[] = []
  toast = ''
  saving = false
  filteredPriorityLengthAtDragStart: number = 0
  priorityLengthAtDragStart: number = 0
  dragstartIndex: number = 0
  markTest: number | null = null
  viewOptions: ViewOption[] = this.orgMode ? [{
    isOrg: true,
    name: 'All Workspaces'
  }] : []

  mounted () {
    if (this.orgMode) {
      this.org.id = this.$route.params.orgId
      this.tapId = this.$route.params.orgId
      this.setViewAndGetUsers(this.$route.params.orgId)
      this.getOrgWorkspaces(this.$route.params.orgId)
    } else if (this.currentStateWorkspace) {
      this.currentStateWorkspaceLoaded(this.currentStateWorkspace, null)
    }
    if (this.$route.params) {
      this.markTest = parseInt(this.$route.params.testId)
    }
  }

  scrollTo ({ offsetTop }: any) {
    setTimeout(() => {
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      })
    }, 0)
  }

  get mode (): Mode {
    if ((this.currentFilter as OrgViewOption).isOrg) {
      return 'organization'
    } else {
      return 'workspace'
    }
  }

  get sortedInProgressTests (): ActiveTest[] {
    return this.activeTests
      .filter(test => {
        return test.payload?.status === graph.TestStatus.InProgress
      })
      .sort((a, b) => {
        // checks tests and gets their lastSubmittedAt time and it doesn't exist, use createdAt
        const testDateA = a.payload?.lastSubmittedAt || a.createdAt
        const testDateB = b.payload?.lastSubmittedAt || b.createdAt

        // if testA's time is more recent, return testB
        return testDateA > testDateB ? 1 : -1
      })
  }

  get filteredPriorityList (): PriorityListItem[] {
    return this.filterIdsInTestArray(this.priority.list, this.activeTests)
  }

  get filteredPriorityTests (): ActiveTest[] {
    return this.mapIdsToTest(this.filteredPriorityList, this.activeTests)
  }

  matchPriorityListItemToActiveTest (activeTest: ActiveTest) {
    return this.priority.list.find(priorityListItem => priorityListItem.workspaceId === activeTest.workspaceId && priorityListItem.testId === activeTest.id)
  }

  get orgRoundRobinList (): PriorityListItem[] {
    const sortedRoundRobinTests = this.datedOrgTests
      .filter(test => !this.priority.list.find(priorityListItem => priorityListItem.testId === test.id && priorityListItem.workspaceId === test.workspaceId))
      .sort((testA, testB) => testA.updatedAt - testB.updatedAt)
    const priorityListItems: PriorityListItem[] = sortedRoundRobinTests.map(datedTest => ({
      testId: datedTest.id,
      workspaceId: datedTest.workspaceId
    }))
    const testsSegmentedByWorkspace = Object.values(
      priorityListItems.reduce((acc: Record<string, PriorityListItem[]>, test: PriorityListItem) => {
        if (!acc[test.workspaceId]) acc[test.workspaceId] = []
        acc[test.workspaceId].push(test)
        return acc
      }, {})
    )
    const maxTestsInOneWorkspace = testsSegmentedByWorkspace.reduce((acc: number, workspaceTests: PriorityListItem[]) => Math.max(acc, workspaceTests.length), 0)
    const sortedFlatTests: PriorityListItem[] = []
    for (let i = 0; i < maxTestsInOneWorkspace; i++) {
      testsSegmentedByWorkspace.forEach(workspace => {
        const nextTestInWorkspace = workspace.shift()
        if (nextTestInWorkspace) sortedFlatTests.push(nextTestInWorkspace)
      })
    }
    return sortedFlatTests
  }

  get filteredOrgRoundRobinList (): PriorityListItem[] {
    return this.orgRoundRobinList.filter(test => this.orgMode ? true : test.workspaceId === this.currentStateWorkspace)
  }

  get filteredOrgRoundRobinTests (): ActiveTest[] {
    return this.filteredOrgRoundRobinList.map(listItem => {
      return this.activeTests.find(activeTest => {
        return activeTest.workspaceId === listItem.workspaceId && activeTest.id === listItem.testId
      })!
    })
  }

  get fullOrgList (): PriorityListItem[] {
    return this.priority.list.concat(this.orgRoundRobinList)
  }

  get fullFilteredList (): PriorityListItem[] {
    return this.filterIdsInTestArray(this.fullOrgList, this.activeTests)
  }

  get capacity (): number {
    const capacity = _.get(this.org, 'payload.capacity', 1)
    return parseInt(capacity, 10)
  }

  get upcomingTestsHelpText (): string {
    return `Your organization runs ${this.capacity} Feedback Loop tests at a time. The above section represents the first ${this.capacity} tests in your queue.`
  }

  get currentStateWorkspace () {
    return this.$route.params.workspaceId
  }

  get isSame (): boolean {
    if (this.prioListNew.length !== this.prioListBackup.length) return false
    return this.prioListNew.every(uid => {
      return this.prioListBackup.indexOf(uid) === this.prioListNew.indexOf(uid)
    })
  }

  get prioListNew (): string[] {
    return this.stringifyArray(this.priority.list)
  }

  get prioListBackup (): string[] {
    return this.stringifyArray(this.priorityListBackup)
  }

  get orgPositions (): number[] {
    const res: number[] = []
    // Priority tests
    this.filteredPriorityList.forEach(needleIds => {
      const index = this.fullOrgList.findIndex(haystackIds => {
        return needleIds.testId === haystackIds.testId &&
          needleIds.workspaceId === haystackIds.workspaceId
      })
      if (index === -1) {
        throw new Error('Test not found')
      }
      res.push(index)
    })
    // Non priority tests
    this.filteredOrgRoundRobinList.forEach(test => {
      const index = this.fullOrgList.findIndex(haystackIds => {
        return test.testId === haystackIds.testId &&
          test.workspaceId === haystackIds.workspaceId
      })
      if (index === -1) {
        throw new Error('Test not found')
      }
      res.push(index)
    })
    return res
  }

  @Watch('currentFilter')
  currentFilterUpdated (newValue: ViewOption, oldValue: ViewOption) {
    if (!newValue === null) {
      // if (this.workspaces[0]) {
      if (this.viewOptions[0]) {
        // this.currentFilter = this.workspaces[0]
        this.currentFilter = this.viewOptions[0]
      }
    } else if ((newValue as OrgViewOption).isOrg) {
      this.getData(this.org.id)
      if (this.orgMode) this.updateUrl({ clearUrl: true })
    } else {
      this.getData(this.org.id, (newValue as graph.Workspace).id)
      if (this.orgMode) this.updateUrl({ id: (newValue as graph.Workspace).id })
    }
  }

  @Watch('editable')
  editableUpdated (newValue: boolean, oldValue: boolean) {
    // Confirm leaving if editable
    if (newValue) {
      window.addEventListener('beforeunload', this.beforeUnload)
    // Reset if not editable
    } else {
      window.removeEventListener('beforeunload', this.beforeUnload)
    }
  }

  setViewAndGetUsers (orgId: string) {
    this.getOrgUsers(orgId)
    if (!this.orgMode) {
      const viewOption: ViewOption = {
        id: store.state.workspace.workspace.id,
        name: store.state.workspace.workspace.name,
        projectCount: 0,
        testCount: 0
      }
      this.viewOptions.push(viewOption)
      this.tapId = store.state.workspace.workspace.id
      this.$set(this.org, 'id', orgId)
    }
    this.setCurrentFilter()
  }

  beforeUnload (event: BeforeUnloadEvent) {
    // Cancel the event
    event.preventDefault()
    // Chrome requires returnValue to be set
    event.returnValue = ''
  }

  mapIdsToTest (idArray: PriorityListItem[], testArray: ActiveTest[]): ActiveTest[] {
    return idArray.map(ids => {
      return testArray.find((test: ActiveTest) => {
        return test && test.workspaceId === ids.workspaceId &&
          test.id === ids.testId
      }) || {} as ActiveTest
    }).filter(pTest => pTest.id)
  }

  filterIdsInTestArray (idArray: PriorityListItem[], testArray: ActiveTest[]): PriorityListItem[] {
    return idArray.filter(ids => {
      return testArray.find(test => {
        return test.workspaceId === ids.workspaceId &&
          test.id === ids.testId
      })
    })
  }

  filterIdsNotInIdArray (idArrayA: PriorityListItem[], idArrayB: PriorityListItem[]): PriorityListItem[] {
    return idArrayA.filter(idsA => {
      return !idArrayB.find(idsB => {
        return idsA.workspaceId === idsB.workspaceId &&
          idsA.testId === idsB.testId
      })
    })
  }

  filterTestsNotInTestArray (testArrayA: ActiveTest[], testArrayB: ActiveTest[]): ActiveTest[] {
    return testArrayA.filter(testA => {
      return !testArrayB.find(testB => {
        return testA.workspaceId === testB.workspaceId &&
          testA.id === testB.id
      })
    })
  }

  stringifyArray (priorityArray: Array<any>): string[] {
    return priorityArray.map(item => item.workspaceId + '_' + (item.testId || item.id))
  }

  getData (orgId: string, workspaceId?: string) {
    this.loading = true
    api.priority(orgId, workspaceId)
      .then((response) => {
        this.activeTests = response.activeTests
        this.priority = response.priority
        this.datedOrgTests = response.datedOrgTests
        this.loading = false
      }).catch((err) => {
        if (err.status === 404) {
          alert('Unable to find organization data. Please contact a CSM.')
        } else if (err.status === 409) {
          alert('The priority has been changed by someone else. Refresh to try again.')
        } else {
          alert('Error occured prioritizing. Please contact a CSM.')
        }
      }).finally(() => {})
  }

  async getOrgUsers (orgId: string) {
    try {
      const response = await api.getOrganizationUsers(orgId)
      this.users = response
    } catch (err) {
      if (err.status === 404) {
        alert('Unable to find organization user data. Please contact a CSM.')
      } else {
        alert('Error loading data. Refresh to try again.')
      }
    }
  }

  async getOrgWorkspaces (orgId: string) {
    try {
      const response = await api.getOrganizationWorkspaces(orgId)
      const viewOptions = response.map(r => {
        return {
          id: r._id,
          name: r.name,
          isOrg: true
        }
      })
      this.$set(this, 'workspaces', viewOptions)
      this.$set(this, 'viewOptions', this.viewOptions.concat(viewOptions))
    } catch (err) {
      if (err.status === 404) {
        alert('Unable to find org workspace data. Please contact a CSM.')
      } else {
        alert('Error loading data. Refresh to try again.')
      }
    }
  }

  @Watch('currentStateWorkspace', { immediate: true })
  currentStateWorkspaceLoaded (newValue: any, oldValue: any) {
    if (newValue && !this.orgMode) {
      this.setViewAndGetUsers(store.state.workspace.workspace.payload.organization.id)
    }
  }

  /**
   * Sets the filter object to filter out the priority data from backend.
   * It only looks through the current list or drop down of filters
   */
  setCurrentFilter () {
    if (this.orgMode) {
      // code for getting wsid filter based on url anchor curreently not using
      // const routedWorkspaceId = location.href.split('#')[1]
      // const currentFilter = this.viewOptions.find(view => (view as Workspace).id === routedWorkspaceId)
      // this.currentFilter = currentFilter || this.viewOptions[0]
      this.currentFilter = this.viewOptions[0]
    } else {
      const viewOption = this.viewOptions.find(view => view.id === this.tapId) || this.viewOptions[0]
      if (viewOption) {
        this.currentFilter = viewOption
      } else {
        this.currentFilter = { isOrg: false, name: '' }
      }
    }
  }

  updateUrl (options: { id?: string, clearUrl?: boolean } = {}) {
    const currentUrlArray = location.href.split('#')
    let newUrl
    if (options.clearUrl) {
      newUrl = currentUrlArray[0]
    } else {
      newUrl = currentUrlArray[0] + `#${options.id}`
    }
    history.replaceState(null, 'Alpha | Priority', newUrl)
  }

  rearrange () {
    this.editable = true
    this.priorityListBackup = A.clone(this.priority.list)
    analytics.track('Priority List Edited', {
      tapId: this.tapId
    })
  }

  cancel () {
    this.editable = false
    this.priority.list = this.priorityListBackup
    this.priorityListBackup = []
  }

  save () {
    const confirmed = confirm(`Changing the order of the ${this.mode} queue will affect all users within the ${this.mode}. Are you sure you want to rearrange your ${this.mode} queue order?`)
    if (confirmed) {
      this.editable = false
      this.savePriority()
    }
  }

  dragstart (test: ActiveTest, index: number) {
    this.draggedTest = test
    this.filteredPriorityLengthAtDragStart = this.filteredPriorityList.length
    this.priorityLengthAtDragStart = this.priority.list.length
    this.dragstartIndex = index
  }

  dragend (test: ActiveTest, index: number) {
    this.draggedTest = null
    this.filteredPriorityLengthAtDragStart = 0
    this.priorityLengthAtDragStart = 0
    this.dragstartIndex = 0
  }

  dragenter (test: ActiveTest, index: number) {
    // Same test?
    if (
      !this.draggedTest ||
      (test.workspaceId === this.draggedTest.workspaceId &&
      test.id === this.draggedTest.id)
    ) {
      return
    }
    const sourceIndex = this.filteredPriorityList
      .concat(this.orgRoundRobinList)
      .findIndex(haystackTest => {
        return this.draggedTest &&
          haystackTest.testId === this.draggedTest.id &&
          haystackTest.workspaceId === this.draggedTest.workspaceId
      })
    const source: ListLocation = {
      test: this.draggedTest,
      index: sourceIndex
    }
    const destination: ListLocation = { test, index }
    this.move(source, destination)
  }

  move (source: ListLocation, destination: ListLocation) {
    let newFilteredPriorityList = A.clone(this.filteredPriorityList)
    this.workspacePriorityBackup = this.stringifyArray(this.filteredPriorityTests)
    if (
      typeof source.index !== 'number' ||
      typeof destination.index !== 'number' ||
      source.index < 0 ||
      destination.index < 0
    ) {
      throw new Error(`One of the indexes is invalid: ${source.index}, ${destination.index}`)
    }
    // Expand newFilteredPriorityList if needed
    if (destination.index + 1 > newFilteredPriorityList.length) {
      const sliceEnd = destination.index - newFilteredPriorityList.length + 1
      const itemsToAdd = this.orgRoundRobinList.slice(0, sliceEnd)
      newFilteredPriorityList = newFilteredPriorityList.concat(itemsToAdd)
    }
    // Add destination priority test
    // If destination is after source: add 1 since we are going to insert
    // an element before it
    let addIndex = destination.index
    if (source.index < destination.index) {
      addIndex++
    }
    newFilteredPriorityList.splice(addIndex, 0, {
      workspaceId: source.test.workspaceId,
      testId: source.test.id,
      prioritizedAt: Math.round(new Date().getTime() / 1000)
    })
    // Remove source priority test
    // If destination is before source: add 1 since we just inserted the
    // an element before it
    let removeIndex = source.index
    if (destination.index < source.index) {
      removeIndex++
    }
    newFilteredPriorityList.splice(removeIndex, 1)
    // Sometimes when dragging you'll drag down adding elements to the
    // priority list, but then drag back up before dropping. Those
    // elements you dragged over are now in the priority list. But
    // its likely we actually didn't want them, since the action wasn't
    // commited to until the drop. So lets remove those.
    let shouldSpliceBelowDrag
    if (this.orgMode) {
      shouldSpliceBelowDrag = destination.index < newFilteredPriorityList.length - 1 &&
        destination.index >= this.filteredPriorityLengthAtDragStart - 1
    } else {
      shouldSpliceBelowDrag = destination.index < newFilteredPriorityList.length - 1 &&
        destination.index > this.dragstartIndex - 1 &&
        destination.index >= this.filteredPriorityLengthAtDragStart - 1
    }
    if (shouldSpliceBelowDrag) {
      newFilteredPriorityList.splice(destination.index + 1)
    }
    let newPriorityList
    if (this.orgMode) {
      // In org mode, much simpler, just set the list
      newPriorityList = newFilteredPriorityList
    } else {
      newPriorityList = this.priority.list.map((test) => {
        if (test.workspaceId === this.currentStateWorkspace) {
          return newFilteredPriorityList.shift()!
        } else return test
      })
    }
    this.priority.list = newPriorityList
  }

  savePriority () {
    this.saving = true
    // Update prioritized at timestamps
    const priorityDifference = this.priorityDiff()
    const changedTests = Object.keys(priorityDifference)
    this.priority.list.filter(({ workspaceId, testId }) => {
      return changedTests.includes((workspaceId + '_' + testId))
    }).forEach(test => {
      test.prioritizedAt = Math.round(new Date().getTime() / 1000)
    })
    this.capturePriorityAnalytics(priorityDifference)
    const data = { priority: this.priority, tap_id: this.tapId }
    api.prioritize(this.org.id, data)
      .then((data) => {
        this.priority.uuid = data.uuid
        this.priorityListBackup = []
        this.toast = 'Priority Updated.'
        setTimeout(() => {
          this.toast = ''
        }, 2000)
      })
      .catch((err: any) => {
        if (err.status === 409) {
          alert('You\'re trying to update an out-of-date version of the queue. Please refresh to load the newest updates.')
        } else {
          alert('Error updating priority. Refresh to try again.')
        }
        this.priority.list = this.priorityListBackup
        this.priorityListBackup = []
      })
      .finally(() => {
        this.saving = false
      })
  }

  capturePriorityAnalytics (priorityDifference: any[]) {
    analytics.track('Priority List Updated', {
      tapId: this.tapId,
      priorityDifference
    })
  }

  priorityDiff (): any[] {
    return this.prioListNew.reduce((acc: any[], id) => {
      const oldWorkspacePosition = this.workspacePriorityBackup.indexOf(id) + 1
      const newWorkspacePosition: number = this.stringifyArray(this.filteredPriorityTests).indexOf(id) + 1
      const oldPosition = this.prioListBackup.indexOf(id) + 1
      const newPosition = this.prioListNew.indexOf(id) + 1
      if (oldPosition !== newPosition) {
        acc.push([id, ['Organization Position Change:', [oldPosition, newPosition], 'Workspace Position Change:', [oldWorkspacePosition, newWorkspacePosition]]])
      }
      return acc
    }, [])
  }

  toTop (test: ActiveTest, index: number) {
    this.workspacePriorityBackup = this.stringifyArray(this.filteredPriorityTests)
    // Expand filtered prio if necessary
    let newFilteredPriorityList
    // Only build out an array to index if in workspace mode
    // We don't care about preserving org position in org mode
    if (index > this.filteredPriorityList.length - 1 && !this.orgMode) {
      newFilteredPriorityList = this.fullFilteredList.slice(0, index + 1)
    } else {
      newFilteredPriorityList = A.clone(this.filteredPriorityList)
    }
    // Remove if already in prio
    if (index < newFilteredPriorityList.length) {
      newFilteredPriorityList.splice(index, 1)
    }
    // Add to beginning
    newFilteredPriorityList.unshift({
      testId: test.id,
      workspaceId: test.workspaceId
    })
    // Build new full prio list
    let newPriorityList
    if (this.orgMode) {
      // Just use the filtered one
      newPriorityList = newFilteredPriorityList
    } else {
      // Build out full prio list from filtered one
      const indexOfLastFilteredPrioItem = this.orgPositions[newFilteredPriorityList.length - 1]
      const newPriorityListLength = Math.max(indexOfLastFilteredPrioItem, this.priority.list.length)
      newPriorityList = A.clone(this.fullOrgList.slice(0, newPriorityListLength + 1))
      // Replace in respective org positions
      newFilteredPriorityList.forEach((data: PriorityListItem, i: number) => {
        const orgPos = this.orgPositions[i]
        newPriorityList[orgPos] = data
      })
    }
    this.priority.list = newPriorityList
  }

  addAboveTestsToPriority (test: ActiveTest, index: number) {
    const orgPos = this.orgPositions[index]
    // Don't shorten the array, shouldn't happen, but just a safeguard
    if (orgPos < this.priority.list.length) return
    this.workspacePriorityBackup = this.stringifyArray(this.filteredPriorityTests)
    this.priority.list = this.fullOrgList.slice(0, orgPos + 1)
  }

  removeTestAtIndexFromPriority (test: ActiveTest, index: number) {
    this.workspacePriorityBackup = this.stringifyArray(this.filteredPriorityTests)
    const orgPos = this.orgPositions[index]
    const newPriorityList = A.clone(this.priority.list)
    newPriorityList.splice(orgPos, 1)
    this.priority.list = newPriorityList
  }
}
